import { getRevenueCategoriesData, searchRevenueCategoriesData } from "@/Api/revenueCategories";
import { AddRevenueCategoryBtn } from "@/App/RevenueCategories/Add";
import { TableData } from "@/App/RevenueCategories/Table";
import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { TypePageActions } from "@/pages/Plans";
import { ApiDataProps } from "@/pages/Tenants";
import { RevenueCategoryProps } from "@/types/revenueCategory";
import { useEffect, useState } from "react";

export const PageList = () => {
  const [categoriesData, setCategoriesData] = useState({} as ApiDataProps<RevenueCategoryProps>);
  const [state, setState] = useState("loading");

  useEffect(() => {
    (async () => {
      const { data } = await getRevenueCategoriesData();
      setCategoriesData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (categoriesData?.current_page < categoriesData?.last_page) {
        setState("loading");

        const { data } = await getRevenueCategoriesData(categoriesData?.current_page + 1);
        setCategoriesData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (categoriesData?.current_page > 1) {
        setState("loading");

        const { data } = await getRevenueCategoriesData(categoriesData?.current_page - 1);
        setCategoriesData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (categoriesData?.current_page !== categoriesData?.last_page) {
        setState("loading");

        const { data } = await getRevenueCategoriesData(categoriesData?.last_page);
        setCategoriesData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
        <h2 className="text-2xl font-semibold flex gap-2 items-center">
          Categorias de Receitas
        </h2>
        <AddRevenueCategoryBtn updateFront={setCategoriesData} />
      </div>
      <div className="flex flex-col gap-3">
        <SearchComponent
          updateFront={setCategoriesData}
          setState={setState}
          funcSearch={searchRevenueCategoriesData}
          placeholder="Pesquisar categorias de receitas"
        />
        {state === "loading" ? (
          <CreateLoaderTable cols={8} lines={6} />
        ) : (
          <TableData
            updateFront={setCategoriesData}
            dataApi={categoriesData}
            pageActions={pageActions}
          />
        )}
      </div>
    </Main>
  );
};

